import { makeStyles } from '@mui/styles'
import * as React from 'react'

import { Theme } from '../../design-tokens/theme'
import List, { ListProps } from '../List'
import ListItem from '../ListItem'

import OrderedListPrefix from './OrderedListPrefix'

export type Interpunct = 'none' | 'dot'

type OrderedListRef = HTMLElementTagNameMap['ul']

interface Props extends ListProps {
  badge?: boolean
  interpunct?: Interpunct
  className?: string
  children: Array<React.ReactElement<any>>
}

const useStyles = makeStyles(({ layoutSpacing }: Theme) => ({
  orderedListItemClass: {
    paddingBottom: layoutSpacing.none,
  },
}))

// eslint-disable-next-line no-shadow
export const OrderedList = React.forwardRef<OrderedListRef, Props>(function OrderedList(
  { className, children, interpunct = 'none', badge = false },
  ref,
) {
  const classes = useStyles()
  return (
    <List disablePadding className={className} ref={ref}>
      {React.Children.map(children, (child, index) => (
        <ListItem key={index} alignItems="flex-start" className={classes.orderedListItemClass}>
          <OrderedListPrefix listingNumber={index + 1} interpunct={interpunct} badge={badge} />
          {child}
        </ListItem>
      ))}
    </List>
  )
})

export default OrderedList
